import React from 'react'
import { Button, Grid, Typography } from '@material-ui/core'
import Page from 'src/components/Page'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import { useParams, useLocation, useNavigate } from 'react-router-dom'
import classnames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { getPaymentInfo, selectorPayment } from '../../app/slices/packageSlice'
import paymentStatus from '../../constants/paymentStatus'
import ipgTypes from '../../constants/ipgTypes'
import { thousandSeperator } from '../../utils/getInitials'

const STATUS = {
  SUCCESS: 'success',
  FAILED: 'failed',
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#f9f9f9',
    padding: theme.spacing(10, 7),
    minHeight: '100%',
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'column',
  },
  container: {
    margin: '0 auto',
    maxWidth: theme.spacing(61),
    borderRadius: theme.spacing(1.25),
    boxShadow: '0 3px 10px 0 rgba(0, 0, 0, 0.16)',
    backgroundColor: '#fff',
    flexDirection: 'column',
    padding: theme.spacing(3, 7),
  },
  titlePayment: {
    textAlign: 'center',
    fontSize: theme.spacing(3),
    fontWeight: 'bold',
  },
  success: {
    color: '#4caf50',
  },
  failed: {
    color: '#ff1f54',
  },
  descPayment: {
    fontSize: theme.spacing(2),
    fontWeight: 500,
    textAlign: 'center',
    color: '#000',
    margin: theme.spacing(2, 0, 4, 0),
  },
  infoTitle: {
    fontSize: theme.spacing(1.7),
    fontWeight: 600,
    color: '#666',
    textAlign: 'center',
  },
  infoDetails: {
    fontSize: theme.spacing(2),
    fontWeight: 700,
    letterSpacing: theme.spacing(0.14),
    textAlign: 'center',
    color: '#000',
    marginTop: theme.spacing(5),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    // marginTop: theme.spacing(11),
  },
  buttonContainer: {
    margin: '4rem auto 0',
  },
  buttonPanel: {},
}))

const Receipt = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const { payId } = useParams()
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const arrayPath = location?.pathname?.split('/')
  const status = arrayPath?.pop()
  const paymentInfo = useSelector(selectorPayment)

  React.useEffect(() => {
    dispatch(getPaymentInfo(payId))
  }, [])

  const handleEnterPanel = () => {
    navigate('/')
  }

  return (
    <Page className={classes.root} title={t('success')}>
      <Grid
        container
        direction="row"
        classes={{ root: classes.container }}
      >
        <Typography
          classes={{
            root: classnames(classes.titlePayment, {
              [classes.success]: status === STATUS.SUCCESS,
              [classes.failed]: status === STATUS.FAILED,
            }),
          }}
          variant="h6"
        >
          {`${t('payment')} ${status === STATUS.SUCCESS ? t('success') : t('failed')}`}
        </Typography>
        <Typography
          classes={{ root: classes.descPayment }}
          variant="body2"
        >
          {status === STATUS.SUCCESS ? t('your_payment_was_successful') : t('sorry_your_payment_failed')}
        </Typography>
        <hr />
        <Typography
          classes={{ root: classes.infoDetails }}
          variant="body2"
        >
          <Typography
            classes={{ root: classes.infoTitle }}
            variant="body2"
          >
            {status === STATUS.SUCCESS ? t('payment_number') : t('track_number')}
            :
          </Typography>
          {payId ?? ''}
        </Typography>
        <Typography
          classes={{ root: classes.infoDetails }}
          variant="body2"
        >
          <Typography
            classes={{ root: classes.infoTitle }}
            variant="body2"
          >
            {t('payment_status')}
            :
          </Typography>
          {t(paymentStatus[paymentInfo?.status] ?? '')}
        </Typography>
        <Typography
          classes={{ root: classes.infoDetails }}
          variant="body2"
        >
          <Typography
            classes={{ root: classes.infoTitle }}
            variant="body2"
          >
            {t('internet_payment_gateway')}
            :
          </Typography>
          {t(ipgTypes[paymentInfo?.ipg] ?? '')}
        </Typography>
        <Typography
          classes={{ root: classes.infoDetails }}
          variant="body2"
        >
          <Typography
            classes={{ root: classes.infoTitle }}
            variant="body2"
          >
            {t('amount')}
            :
          </Typography>
          {thousandSeperator(paymentInfo?.amount ?? '')}
        </Typography>
        {
          status === STATUS.FAILED && (
            <Typography
              classes={{ root: classes.infoDetails }}
              variant="body2"
            >
              <Typography
                classes={{ root: classes.infoTitle }}
                variant="body2"
              >
                {t('error_message')}
                :
              </Typography>
                {paymentInfo?.errorMessage ?? ''}
            </Typography>
          )
        }
        <Typography
          classes={{ root: classes.infoDetails }}
          variant="body2"
        >
          <Typography
            classes={{ root: classes.infoTitle }}
            variant="body2"
          >
            {t('Package_name')}
            :
          </Typography>
          {paymentInfo?.userPackage?.package?.name ?? ''}
        </Typography>
        <Typography
          classes={{ root: classes.infoDetails }}
          variant="body2"
        >
          <Typography
            classes={{ root: classes.infoTitle }}
            variant="body2"
          >
            {`${t('national_code')} ${t('user')}`}
            :
          </Typography>
          {paymentInfo?.payer?.userName ?? ''}
        </Typography>
      </Grid>
      <Grid xs={12} sm={6} md={3} classes={{ root: classes.buttonContainer }}>
        <Button
          fullWidth
          classes={{ root: classes.buttonPanel }}
          type="submit"
          variant="contained"
          color="primary"
          size="large"
          onClick={handleEnterPanel}
        >
          {t('login_to_the_user_panel')}
        </Button>
      </Grid>
    </Page>
  )
}

Receipt.propTypes = {
}

export default Receipt
